var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.527 240.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #83b542;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_001-car-seat",
    "data-name": "001-car-seat",
    className: "cls-1",
    d: "M211.744,6.089A19.216,19.216,0,0,0,197.52,0H182.377c-11.16,0-21.811,8.942-23.74,19.934l-.955,5.436a17.544,17.544,0,0,0,3.639,14.589,17.543,17.543,0,0,0,13.74,6.106h19.561a21.174,21.174,0,0,0,7.778-1.5l-2.079,17.761a16.739,16.739,0,0,0-6.507-1.289H171.5c-9.561,0-18.952,7.609-20.936,16.961l-19.732,93.027-93.1-6.69c-5.031-.36-9.231,1.345-11.835,4.693-2.439,3.136-3.152,7.343-2.009,11.847l10.824,42.618c2.345,9.233,12,16.746,21.53,16.746H175.208a19.917,19.917,0,0,0,19.354-17.411L209.834,78.843a17.34,17.34,0,0,0,.069-2.437l5.227-44.648a21.032,21.032,0,0,0,1.354-6.087l.346-4.97A19.207,19.207,0,0,0,211.744,6.089Z",
    transform: "translate(-23.353)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeat);
export default __webpack_public_path__ + "static/media/seat.bf6dc9bc15f18cc4747dfc871e19bc4b.svg";
export { ForwardRef as ReactComponent };